import { render } from "./course-watch.vue?vue&type=template&id=ecb10bee&scoped=true"
import script from "./course-watch.vue?vue&type=script&lang=js"
export * from "./course-watch.vue?vue&type=script&lang=js"

import "./course-watch.vue?vue&type=style&index=0&id=ecb10bee&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb10bee"]])

export default __exports__